<nh-form [formGroup]="getForm()" [mode]="mode" (validate)="onValidate($event)">
  @if (showWarning) {
  <div class="alert alert-warning" role="alert">
    <div>
      <span><i class="fa fa-exclamation-triangle"></i></span>&nbsp;&nbsp;{{
        "APP_SUMARY_VALIDATION_MESSAGE" | globalTranslate
      }}
    </div>
  </div>
  }

  <section class="summary-left">
    <div
      id="accordion"
      [innerHtml]="getValue('data.summary') | htmlTranslate | sanitize"
    ></div>
  </section>
</nh-form>
